import React, { useRef } from "react"
import ReactResizeDetector from "react-resize-detector"

/**
 * TL;DR it's silly, and you should change it if you can
 *
 * I believe who ever that read this code would be confused, if you feel that
 * please read the full explanation below
 *
 *
 * Background Problem:
 * There is a problem in Wheel component because we're using Konva
 * (which is a Canvas) so it's not tied up to the DOM and not listening to DOM
 * changes. Meaning that everytime browser loaded some media that could change
 * the layout, this Canvas / Konva would never get updated, in our case it's
 * the Font.
 *
 *
 * Ideal Solution:
 * Providing an observer that observe Fonts changes / mutation and run a
 * callback function would be very nice. But this is takes a lot of times, and
 * there's no API provided by the Browser, there is things like
 * `document.fonts` though, but its still in the Working Drafts (hasn't become
 * a standard yet)
 * another solution is using a library such as (webfontloader)
 * https://github.com/typekit/webfontloader , but at the time I'm writing this
 * I don't have a lot of time
 *
 *
 * Current Solution:
 * We are observing / watching size changes in this span element that only
 * contains raw text, the idea is whenever Browser finish to load a font at
 * least it would change the size of this span a bit and we can use it as
 * a measurement that say `hey, the font has changed` and run the onChange func
 * Those strange text is also intentional because I assume every of those
 * char's size is different across Font Families, so it increase the chances
 * for span getting resized when font has changed
 */
const DetectFontChange = ({ onChange }) => {
  const spanRef = useRef()

  /**
   * Get actual CSS value used in paint event, even if it's not defined to the
   * element or through inheritance
   * @param {HTMLElement} element
   * @param {String} property CSS property you wanna get (ex. font-size)
   * @return {String}
   */
  const getRenderedCSS = (element, property) => {
    return window.getComputedStyle(element, null).getPropertyValue(property)
  }

  const handleChange = () => {
    const fontFamilies = getRenderedCSS(spanRef.current, "font-family")
    const usedFontFamily = fontFamilies.split(",")[0]
    const fontSize = getRenderedCSS(spanRef.current, "font-size")
    const textTransform = getRenderedCSS(spanRef.current, "text-transform")
    const textStyle = {
      fontFamily: usedFontFamily,
      fontSize: parseInt(fontSize),
      textTransform,
    }
    // console.log({ textStyle })
    if (onChange) onChange(textStyle)
  }

  return (
    <ReactResizeDetector handleWidth handleHeight onResize={handleChange}>
      <span
        ref={spanRef}
        className="font-wheel"
        style={{
          position: "absolute",
          zIndex: -1,
          opacity: 0,
          pointerEvents: "none",
          display: "inline-block",
        }}
      >
        F0nt l0@d3r w@tchEr//-_+=
      </span>
    </ReactResizeDetector>
  )
}

export default DetectFontChange
